export class WorkspaceGcp {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WorkspaceGcp.attributeTypeMap;
    }
    constructor() {
    }
}
